import { useApp } from '@tldraw/editor'
import { track } from 'signia-react'
import { useActions, useTranslation } from '../../hooks'
import { Button, kbdStr } from '../primitives'

export const DuplicateButton = track(function DuplicateButton() {
	const app = useApp()
	const actions = useActions()
	const msg = useTranslation()
	const action = actions['duplicate']

	const noSelected = app.selectedIds.length <= 0

	return (
		<Button
			icon={action.icon}
			onClick={action.onSelect}
			disabled={noSelected}
			title={`${msg(action.label!)} ${kbdStr(action.kbd!)}`}
			smallIcon
		/>
	)
})
